import { Button, Space, Table, Tooltip } from "antd";
import { FileDoneOutlined, FileTextOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCandidateList, getJobList, stageIdToKey } from "../../redux/rtk/features/hiring/hiringSlice";
import "./Hiring.css";

const OFFER_STAGE_ID = 4;

const fullName = (record) => {
	const first = record.FirstName ?? record.firstName ?? "";
	const middle = record.MiddleName ?? record.middleName ?? "";
	const last = record.LastName ?? record.lastName ?? "";
	return [first, middle, last].filter(Boolean).join(" ") || (record.name ?? record.Name ?? record.candidateName ?? "—");
};

const HiringOfferList = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { candidateList, jobList, loading } = useSelector((state) => state.hiring);

	useEffect(() => {
		dispatch(getJobList());
		dispatch(getCandidateList({ page: 1, limit: 200 }));
	}, [dispatch]);

	// Candidates whose stage is "Offer" (StageId === 4)
	const candidatesAtOfferStage = (candidateList || []).filter((c) => {
		const stageId = c.StageId ?? c.stageId;
		const key = stageId != null ? stageIdToKey(stageId) : null;
		return key === "OFFER" || Number(stageId) === OFFER_STAGE_ID;
	});

	const getJobForCandidate = (candidate) => {
		const jobId = candidate.JobOpeningId ?? candidate.jobOpeningId ?? candidate.jobId ?? candidate.JobId;
		if (jobId == null) return null;
		return (jobList || []).find(
			(j) => (j.JobOpeningId ?? j.id ?? j.JobId) === jobId
		) || null;
	};

	const handleOpenLetter = (letterType, candidate) => {
		const job = getJobForCandidate(candidate);
		navigate("/admin/hr/letter-generation", {
			state: { letterType, candidate: { ...candidate }, job: job ? { ...job } : null },
		});
	};

	const offerStageColumns = [
		{
			title: "Candidate Name",
			key: "name",
			render: (_, record) => fullName(record),
		},
		{
			title: "Job",
			key: "job",
			render: (_, record) => {
				const job = getJobForCandidate(record);
				return job?.Title ?? job?.title ?? job?.JobTitle ?? record.JobTitle ?? record.jobTitle ?? "—";
			},
		},
		{
			title: "Action",
			key: "action",
			width: 140,
			render: (_, record) => (
				<Space size="middle">
					<Tooltip title="Generate Offer Letter">
						<Button
							type="text"
							icon={<FileTextOutlined />}
							onClick={() => handleOpenLetter("offer", record)}
						/>
					</Tooltip>
					<Tooltip title="Generate Appointment Letter">
						<Button
							type="text"
							icon={<FileDoneOutlined />}
							onClick={() => handleOpenLetter("appointment", record)}
						/>
					</Tooltip>
				</Space>
			),
		},
	];

	const offerStageDataSource = candidatesAtOfferStage.map((c, index) => ({
		...c,
		key: c.CandidateId ?? c.id ?? c.candidateId ?? index,
	}));

	return (
		<>
			<h4 className="mb-3">Candidates at Offer stage</h4>
			<Table
				columns={offerStageColumns}
				dataSource={offerStageDataSource}
				loading={loading}
				pagination={{ pageSize: 10 }}
				locale={{ emptyText: "No candidates at Offer stage. Move candidates to Offer in the Pipeline." }}
			/>
		</>
	);
};

export default HiringOfferList;
